import { render, staticRenderFns } from "./start.vue?vue&type=template&id=7afee264&"
import script from "./start.ts?vue&type=script&lang=ts&"
export * from "./start.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports